/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Studio_Pick_TitleInputs */

const en_ui_studio_pick_title = /** @type {(inputs: Ui_Studio_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add to route`)
};

const de_ui_studio_pick_title = /** @type {(inputs: Ui_Studio_Pick_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zur Route hinzufügen`)
};

/**
* | output |
* | --- |
* | "Add to route" |
*
* @param {Ui_Studio_Pick_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_studio_pick_title = /** @type {((inputs?: Ui_Studio_Pick_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Studio_Pick_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_studio_pick_title(inputs)
	return de_ui_studio_pick_title(inputs)
});